import { VerticalTabListCombinedProps } from './types';

const usePresenter = (props: VerticalTabListCombinedProps): VerticalTabListCombinedProps => {
  return props;
};

export default usePresenter;
